<template>
    <div>
        <div class="main-container">
            <KidHeader :profileId="profileId" :serialNumber="serialNumber" />
            <div class="profile-section mb-2">
                <div class="pl-2">
                    <span>
                        <a class="text-black" href="javascript:void(0)" @click="$router.push({ path: '/kids-device', query: { profileId: this.profileId, serialNumber: this.serialNumber } })"><i class="fas fa-long-arrow-alt-left"></i>&nbsp; <b>Home</b></a>
                    </span>
                </div>
            </div>
            <div class="profile-section" :style="{ 'padding': 'unset'}">
                <div class="form-row align-items-center pt-2 m-1">
                    <!-- Search Input -->
                    <div class="col-12 col-md-6 mb-2">
                        <div class="">
                            <input type="text" class="form-control" placeholder="Title" v-model="title" />
                        </div>
                    </div>

                    <div class="col-12 col-md-6 mb-2">
                        <div class="">
                            <input type="text" class="form-control" placeholder="Message" v-model="message" />
                        </div>
                    </div>
                </div>
                <div class="form-row align-items-center m-1">
                    <!-- Search Input -->
                    <div class="col-12 col-md-6 mb-2">
                        <div class="">
                            <input type="text" class="form-control" placeholder="Package Name" v-model="packageName" />
                        </div>
                    </div>

                    <!-- Filter Dropdown -->
                    <div class="col-12 col-md-4 mb-2">
                        <select class="form-control" aria-label="Status" v-model="action"> 
                            <option value="">Select Action</option>
                            <option value="uninstall_app">Uninstall Application</option>
                            <option value="enable_app">Enable Application</option>
                            <option value="disable_app">Disable Application</option>
                            <option value="start_kid_app">Start Kid App</option>
                            <option value="stop_knox">Stop Knox</option>
                            <option value="enable_vpn">Enable VPN</option>
                            <option value="disable_vpn">Disable VPN</option>
                            <option value="enable_dns">Enable DNS</option>
                            <option value="disable_dns">Disable DNS</option>
                        </select>
                    </div>

                    <!-- Created Button -->
                    <div class="col-12 col-md-2 mb-2">
                        <button  class="btn btn-success btn-block" @click="sendFcmCommand()" :disabled="isDisabled">
                            Send<span v-if="isDisabled"><i class="fa fa-spinner fa-spin ml-2"></i></span>
                        </button>
                    </div>

                </div>
            </div>
            <div class="profile-section pt-2">
                <button type="button" class="btn btn-primary float-right mb-2 mr-2" :style=" { 'background': '#0073EE', 'border-radius': '20px', 'width': '30%' }" @click="sendFetchLogRequest()" :disabled="isDisabled">
                    Fetch Log<span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
                </button>
                <div class="pt-3 m-2" :style="{ 'padding-right': '2px'}">
                    <div class="input-group border">
                        <div class="input-group-prepend">
                            <div class="input-group-text" :style="{ 'background-color': 'white', 'border-left': 'unset','border-top': 'unset', 'border-bottom': 'unset' }" id="btnGroupAddon">
                                <a class="text-black" href="javascript:void(0)" @click="previousDate()">
                                    <!--<i class="fas fa-chevron-circle-left"></i>-->
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect y="24" width="24" height="24" rx="12" transform="rotate(-90 0 24)" fill="#F2F2F2"/>
                                        <path d="M13.6667 15.3333L10.4003 12.157C10.311 12.0703 10.311 11.9296 10.4003 11.8429L13.6667 8.66663" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>

                                </a>
                            </div>
                        </div>
                        <div class="form-control text-center" :style="{ 'border': 'unset', 'font-weight': 'bold' }">{{ this.formattedDate }}</div>
                        <div class="input-group-prepend">
                            <div class="input-group-text" :style="{ 'background-color': 'white', 'border-left': 'unset','border-top': 'unset', 'border-bottom': 'unset' }" id="btnGroupAddon">
                                <a class="text-black" href="javascript:void(0)" @click="nextDate()">
                                    <!--<i class="fas fa-chevron-circle-right"></i>-->
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="24" width="24" height="24" rx="12" transform="rotate(90 24 0)" fill="#F2F2F2"/>
                                        <path d="M10.3333 8.66671L13.5997 11.843C13.689 11.9297 13.689 12.0704 13.5997 12.1571L10.3333 15.3334" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>

                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-for="(device, index) in allDevices" :key="index" class="device-card">
                    <strong>created at:</strong> {{ device.created_at }}
                    <div v-for="(value, key) in device.logData" :key="key" class="device-detail">
                        <!-- Check if value is an array -->
                        <div v-if="Array.isArray(value)">
                        <strong>{{ key }}:</strong>
                        <ul>
                            <li v-for="(item, i) in value" :key="i">
                            <!-- Check if item is an object -->
                            <div v-if="typeof item === 'object'">
                                <div v-for="(subVal, subKey) in item" :key="subKey">
                                {{ subKey }}: {{ subVal }}
                                </div>
                            </div>
                            <div v-else>
                                {{ item }}
                            </div>
                            </li>
                        </ul>
                        </div>
                        <!-- If not an array -->
                        <div v-else>
                            <strong>{{ key }}:</strong> {{ value || 'N/A' }}
                        </div>
                    </div>
                </div>
                <label class="text-info pl-2" v-if="allDevices.length == 0">No data found.</label>
            </div>
            <KidFooter />
        </div>
    </div>
</template>
<script>
import KidHeader from '@/components/KidHeader.vue'
import KidFooter from '@/components/KidFooter.vue'
import KidsService from "../../services/KidsService";
let options = { weekday: 'short', month: 'long', day: 'numeric' };
export default {
  name: 'Device Logs',
  components: {
    KidHeader,
    KidFooter
  },
  data() {
    return {
        isDisabled: false,
        profileId: this.$route.query.profileId,
        serialNumber: this.$route.query.serialNumber,
        formattedDate: new Date().toLocaleDateString("en-US", options),
        currentDate: new Date(),
        filterType: "Day",
        allDevices: [],

        title: "",
        message: "",
        action: "",
        packageName: "",
    }
  },
  methods: {
    previousDate() {
        if (this.filterType == "Day") {
            let day = this.currentDate.getTime() - (1 * 24 * 60 * 60 * 1000);
            this.currentDate.setTime(day);
            this.formattedDate = this.currentDate.toLocaleDateString("en-US", options);
        } else {
            this.formattedDate = "Previous Week"
            this.weekType = "Previous";
        }
        this.getDeviceLogs();
        
    },
    nextDate() {
        if (this.filterType == "Day") {
            let day = this.currentDate.getTime() + (1 * 24 * 60 * 60 * 1000);
            this.currentDate.setTime(day);
            this.formattedDate = this.currentDate.toLocaleDateString("en-US", options)
        } else {
            this.formattedDate = "This Week",
            this.weekType = "Current";    
        }
        this.getDeviceLogs();
    },
    async getDeviceLogs() {
        let data = { currentDate: this.currentDate, serialNumber: this.serialNumber };
        await KidsService.getDeviceLogs(data)
        .then((response) => {
          this.allDevices = response.data.data;
          this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    async sendFetchLogRequest() {
        this.isDisabled = true;
        let data = { serialNumber: this.serialNumber };
        await KidsService.sendFetchLogRequest(data)
        .then((response) => {
          this.isDisabled = false;
          this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
          this.isDisabled = false;
        });
    },
    async sendFcmCommand() {
        this.isDisabled = true;
        let data = {
            title: this.title,
            message: this.message,
            packageName: this.packageName,
            action: this.action,
            serialNumber: this.serialNumber
        }
        await KidsService.sendFcmCommand(data)
        .then((response) => {
          this.isDisabled = false;
          this.$toast.success(response.data.respones_msg);
          this.title = "";this.message="";this.packageName="",this.action="";
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
          this.isDisabled = false;
        });
    }
  },
  beforeMount() {
    this.getDeviceLogs();
  },
}
</script>
<style scoped>
.device-card {
  border: 1px solid #ccc;
  padding: 1em;
  margin-bottom: 1.5em;
  border-radius: 8px;
  background: #f9f9f9;
}
.device-detail {
  margin-bottom: 0.5em;
}
</style>